import { Typography } from '@material-ui/core';
import { Stack } from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import { ReactNode } from 'react';

interface PostingViewCardProps {
  header?: ReactNode;
  children: ReactNode;
}

export function PostingDetailsCard({ header, children }: PostingViewCardProps) {
  return (
    <Box backgroundColor="White" padding="small">
      <Stack>
        {header && <Typography variant="h4">{header}</Typography>}

        <div>{children}</div>
      </Stack>
    </Box>
  );
}
